import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import OneButtonModalFooter from "components/modals/OneButtonModalFooter";
import UserProfileTooltip from "components/tooltip/UserProfileTooltip.component";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { Assignment, Explanation } from "types/workflowDetailsWizard";
import { WorkflowDetailsUsersProps } from "types/modals";

const WorkflowDetailsUsers = ({
    more,
    closeModal,
    loopFocus,
    initialFocusRef,
}: WorkflowDetailsUsersProps): React.ReactElement => {
    const { translate } = useTranslation();
    const assignments = more?.assignments ?? [];

    return (
        <>
            <div className="ga-modal__content">
                <ul className="px-0 mb-0">
                    {assignments.map((assignment: Assignment) => (
                        <li key={assignment.userDTO.idUser} className="py-3">
                            <UserProfileTooltip user={assignment.userDTO} />
                            {assignment.explanations?.map((explanation: Explanation, index: number) => (
                                <div key={`${explanation.action}-${index}`} className="mt-2 ga-text-helper">
                                    {explanation.action}
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            </div>
            <OneButtonModalFooter
                tabIndex={MODAL_CONTENT_TAB_INDEX}
                enabled={true}
                callback={closeModal}
                text={translate("popUp.close")}
                loopFocus={loopFocus}
                buttonRef={initialFocusRef}
            />
        </>
    );
};

export default WorkflowDetailsUsers;
